import {EffectCard} from "../type";

export const BrandName = "HueFuse";
export const wasmPaths = {
    url: 'https://cdn.jsdelivr.net/npm/onnxruntime-web@1.18.0/dist/',
    backupUrl: 'https://cdn.jsdelivr.net/npm/onnxruntime-web@1.16.3/dist/',
    specificUrl: 'https://cdn.jsdelivr.net/npm/onnxruntime-web@1.18.0/dist/ort-wasm-simd.jsep.wasm',
}

export const coreUrl = 'https://unpkg.com/@ffmpeg/core@0.12.10/dist/umd/ffmpeg-core.js';
export const wasmUrl = 'https://unpkg.com/@ffmpeg/core@0.12.10/dist/umd/ffmpeg-core.wasm';

export const ModelTypeConstant = {
    REMOVE_BG: 'removeBg',// 移除背景
    REPLACE_CLOTH: 'replaceCloth',// 换衣
    STYLE_CHANGE_CLIP: 'style_change_Clip',// 图片风格改变
    IN_PAINT_: "in_paint",// 图像修补
    SUPER_RESOLUTION: "super_resolution",// 图像高清化
}

export const GlobalRouterPath = {
    HOME: "/",
    APPLICATION: "/application",
    PRICING: "/pricing",
    DOCS: "/documentation",

    // tools
    IMAGE_REMOVE_BG: "/imageRemoveBg",
    IMAGE_IN_PAINT: "/imageInpaint",
    IMAGE_ENHANCE: "/imageEnhance",
    VIDEO_ENHANCE: "/videoEnhance",
    IMAGE_COMPRESSOR: "/imageCompressor",
    VIDEO_CONVERT: "/videoConvert",
}

// 顶部菜单
export const Menus = [
    {
        text: 'My Tools',
        children: [
            {
                href: GlobalRouterPath.IMAGE_REMOVE_BG,
                text: 'AI ImageBg Remover',
                icon: "/images/my_tools/removeBg.png", // 图标组件
                desc: 'Transform Your Visuals with Precision and Speed，' +
                    'One-Click Automatic in 2 Second' // 描述文本
            },
            {
                href: GlobalRouterPath.IMAGE_REMOVE_BG,
                text: 'AI Photo to Animation',
                icon: "/images/my_tools/removeBg.png", // 图标组件
                desc: 'Convert images into animation' // 描述文本
            },
            {
                href: GlobalRouterPath.IMAGE_IN_PAINT,
                text: 'AI Magic Eraser',
                icon: "/images/my_tools/inpaintImage.png", // 图标组件
                desc: 'Erase unwanted parts from the image' // 描述文本
            },
            {
                href: GlobalRouterPath.IMAGE_ENHANCE,
                text: 'AI Image Enhancer',
                icon: "/images/my_tools/imageEnhancer.png", // 图标组件
                desc: 'Improve Image Quality' // 描述文本
            },
            {
                href: GlobalRouterPath.VIDEO_ENHANCE,
                text: 'AI Video Enhancer',
                icon: "/images/my_tools/imageEnhancer.png", // 图标组件
                desc: 'Improve Video Quality' // 描述文本
            },
            {
                href: GlobalRouterPath.IMAGE_COMPRESSOR,
                text: 'Online IMG Compressor',
                icon: "/images/my_tools/imgCompressor.png", // 图标组件
                desc: 'Free online image compression – reduce size, keep quality."' // 描述文本
            },
            {
                href: GlobalRouterPath.VIDEO_CONVERT,
                text: 'Online Video Convertor',
                icon: "/images/my_tools/videoConvertor.png", // 图标组件
                desc: 'Free online video conversion"' // 描述文本
            },
        ],
        footer: {  // 底部操作区
            actions: [
                { text: 'View All', href: '/' }
            ]
        }
    },
    {
        href: GlobalRouterPath.APPLICATION,
        text: 'App',
    },
    {
        href: GlobalRouterPath.PRICING,
        text: 'Pricing',
    },
    {
        href: GlobalRouterPath.DOCS,
        text: 'Docs',
    },
];

export const enhancerModelKeys = {
    NORMAL_MODEL: 0,// 4倍图像增强
    HD_MODEL: 1,// 8倍图像增强
    ANIME_HD_MODEL: 2,// 4倍动画图像增强
    ANIME_VIDEO_HD_MODEL: 3,// 4倍动画视频增强
}


/**
 * 特效卡片数据
 */
export const EffectCards: Array<EffectCard> = [
    {
        id: 'pixelate',
        icon: 'fa-th',
        title: 'Pixel Art',
        description: 'Transform photos into retro pixelated styles with customizable pixel dimensions and color depth.'
    },
    {
        id: 'watercolor',
        icon: 'fa-paint-brush',
        title: 'Watercolor Effect',
        description: 'Simulate traditional watercolor brushstrokes and pigment diffusion for painterly artworks.'
    },
    {
        id: 'glitch',
        icon: 'fa-bolt',
        title: 'Glitch Art',
        description: 'Create futuristic digital distortion effects with programmable intensity parameters.'
    },
    {
        id: 'neon',
        icon: 'fa-lightbulb',
        title: 'Neon Glow',
        description: 'Apply electroluminescent edge effects simulating urban nightscapes.'
    },
    {
        id: 'mosaic',
        icon: 'fa-shapes',
        title: 'Interactive Mosaic',
        description: 'Develop touch-responsive tiling effects with progressive detail revelation.'
    },
    {
        id: 'sketch',
        icon: 'fa-pencil-alt',
        title: 'Sketch Conversion',
        description: 'Convert photographs to pencil drawing styles with parametric control.'
    }
];

/**
 * 背景移除模型
 */
export const RemoveBgModelList = [
    {
        name: 'generalRmBgLite',
        url: 'https://hf-mirror.com/LXReaper/image_project/resolve/main/generalRmBgLite.onnx',
        backupUrl: 'https://huggingface.co/LXReaper/image_project/resolve/main/generalRmBgLite.onnx',
        backupUrl1: 'https://huggingface.co/LXReaper/image_project/resolve/main/generalRmBgLite.onnx',
        inputType: 'float32',
        inputName: 'input',
        targetWidth: 1024,
        targetHeight: 1024,
        defaultExecutionProviders: "webgpu"
    },
    {
        name: 'generalRmBg',
        url: 'https://hf-mirror.com/LXReaper/image_project/resolve/main/generalRmBg.onnx',
        backupUrl: 'https://huggingface.co/LXReaper/image_project/resolve/main/generalRmBg.onnx',
        backupUrl1: 'https://code.openxlab.org.cn/api/v1/repos/LXReaper/image_project/media/generalRmBg.onnx?ref=main&nonce=1747375221875',
        inputType: 'float32',
        inputName: 'input',
        targetWidth: 1024,
        targetHeight: 1024,
        defaultExecutionProviders: "webgpu"
    },
    {
        name: 'generalRmBgPro',
        url: 'https://hf-mirror.com/LXReaper/image_project/resolve/main/generalRmBgPro.onnx',
        backupUrl: 'https://huggingface.co/LXReaper/image_project/resolve/main/generalRmBgPro.onnx',
        backupUrl1: 'https://huggingface.co/LXReaper/image_project/resolve/main/generalRmBgPro.onnx',
        inputType: 'float32',
        inputName: 'input',
        targetWidth: 1024,
        targetHeight: 1024,
        defaultExecutionProviders: "webgpu"
    },
    {
        name: 'generalRmBgProMax',
        url: 'https://hf-mirror.com/LXReaper/image_project/resolve/main/generalRmBgProMax.onnx',
        backupUrl: 'https://huggingface.co/LXReaper/image_project/resolve/main/generalRmBgProMax.onnx',
        backupUrl1: 'https://huggingface.co/LXReaper/image_project/resolve/main/generalRmBgProMax.onnx',
        inputType: 'float32',
        inputName: 'input',
        targetWidth: 1024,
        targetHeight: 1024,
        defaultExecutionProviders: "webgpu"
    },
    {
        name: 'humanRmBg',
        url: 'https://hf-mirror.com/LXReaper/image_project/resolve/main/humanRmBg.onnx',// /models/humanRmBg.onnx
        backupUrl: 'https://huggingface.co/LXReaper/image_project/resolve/main/humanRmBg.onnx',
        backupUrl1: 'https://code.openxlab.org.cn/api/v1/repos/LXReaper/image_project/media/humanRmBg.onnx?ref=main&nonce=1747375241563',
        inputType: 'float32',
        inputName: 'input.1',
        targetWidth: 320,
        targetHeight: 320,
        defaultExecutionProviders: "wasm"
    },
    {
        name: 'animeRmBg',
        url: 'https://hf-mirror.com/LXReaper/image_project/resolve/main/animeRmBg.onnx',
        backupUrl: 'https://huggingface.co/LXReaper/image_project/resolve/main/animeRmBg.onnx',
        backupUrl1: 'https://code.openxlab.org.cn/api/v1/repos/LXReaper/image_project/media/animeRmBg.onnx?ref=main&nonce=1747375174644',
        inputType: 'float32',
        inputName: 'img',
        targetWidth: 1024,// 自己定
        targetHeight: 1024,// 自己定
        defaultExecutionProviders: "wasm"
    },
    {
        name: 'isnet',
        url: 'https://hf-mirror.com/LXReaper/image_project/resolve/main/isnet.onnx',
        backupUrl: 'https://huggingface.co/LXReaper/image_project/resolve/main/isnet.onnx',
        backupUrl1: 'https://huggingface.co/LXReaper/image_project/resolve/main/isnet.onnx',
        inputType: 'float32',
        inputName: 'input',
        targetWidth: 1024,
        targetHeight: 1024,
        defaultExecutionProviders: "webgpu"
    },
    {
        name: 'isnet_model_fp16',
        url: 'https://hf-mirror.com/LXReaper/image_project/resolve/main/isnet_model_fp16.onnx',
        backupUrl: 'https://huggingface.co/LXReaper/image_project/resolve/main/isnet_model_fp16.onnx',
        backupUrl1: 'https://huggingface.co/LXReaper/image_project/resolve/main/isnet_model_fp16.onnx',
        inputType: 'float32',
        inputName: 'input',
        targetWidth: 1024,
        targetHeight: 1024,
        defaultExecutionProviders: "webgpu"
    },
    {
        name: 'isnet-carve-photo',
        url: 'https://hf-mirror.com/LXReaper/image_project/resolve/main/isnet-carve-photo.onnx',
        backupUrl: 'https://huggingface.co/LXReaper/image_project/resolve/main/isnet-carve-photo.onnx',
        backupUrl1: 'https://huggingface.co/LXReaper/image_project/resolve/main/isnet-carve-photo.onnx',
        inputType: 'float32',
        inputName: 'input',
        targetWidth: 1024,
        targetHeight: 1024,
        defaultExecutionProviders: "webgpu"
    },
]

/**
 * 图像风格转换模型
 */
export const StyleChangeModelList = [
    {
        name: 'ToonClip',
        url: 'https://hf-mirror.com/LXReaper/image_project/resolve/main/ToonClip.onnx',
        backupUrl: 'https://huggingface.co/LXReaper/image_project/resolve/main/ToonClip.onnx',
        backupUrl1: 'https://code.openxlab.org.cn/api/v1/repos/LXReaper/image_project/media/ToonClip.onnx?ref=main&nonce=1747374337768',
        inputType: "float32",
        inputName: 'input',
        targetWidth: 1024,
        targetHeight: 1024,
        TensorShape: [1, 3, 1024, 1024],// 输入的张量形状
    },
    {
        name: 'arbitrary_image_stylization',
        url: '/models/arbitrary_image_stylization.onnx',
        backupUrl: '/models/arbitrary_image_stylization.onnx',
        backupUrl1: '/models/arbitrary_image_stylization.onnx',
        inputType: "float32",
        inputContentImageName: 'placeholder',
        inputStyleImageName: 'placeholder_1',
        targetWidth: 1024,// 自己定
        targetHeight: 1024,// 自己定
        TensorShape: [1, 1024, 1024, 3],// 输入的张量形状
    },
];

/**
 * 换衣模型
 */
export const ReplaceClothModelList = [
    {
        name: 'u2net_cloth_seg',
        url: 'https://hf-mirror.com/LXReaper/image_project/resolve/main/u2net_cloth_seg.onnx',
        backupUrl: 'https://huggingface.co/LXReaper/image_project/resolve/main/u2net_cloth_seg.onnx',
        backupUrl1: 'https://code.openxlab.org.cn/api/v1/repos/LXReaper/image_project/media/u2net_cloth_seg.onnx?ref=main&nonce=1747375361694',
        inputType: "float32",
        inputName: 'input',
        targetWidth: 768,
        targetHeight: 768,
    },
]


/**
 * 图像修补模型列表
 */
export const InPaintModelList = [
    {
        name: "image_inPaint_1",
        url: "https://hf-mirror.com/LXReaper/image_project/resolve/main/image_inPaint_1.onnx",
        backupUrl: "https://huggingface.co/LXReaper/image_project/resolve/main/image_inPaint_1.onnx",
        backupUrl1: "https://code.openxlab.org.cn/api/v1/repos/LXReaper/image_project/media/image_inPaint_1.onnx?ref=main&nonce=1747375260754",
        inputType: "uint8",
        imageInputName: "image",
        channelNum: 3,
        maskInputName: "mask",
        maskChannelNum: 1,
        targetWidth: 1024,
        targetHeight: 1024,
    }
]

/**
 * 图像高清化模型
 */
export const SuperResolutionModelList = [
    {
        name: "superResolution_1",
        url: "https://hf-mirror.com/LXReaper/image_project/resolve/main/superResolution_1.onnx",
        backupUrl: "https://huggingface.co/LXReaper/image_project/resolve/main/superResolution_1.onnx",
        backupUrl1: "https://code.openxlab.org.cn/api/v1/repos/LXReaper/image_project/media/superResolution_1.onnx?ref=main&nonce=1747375289190",
        inputType: "float32",
        inputName: 'input.1',
        targetWidth: 64,
        targetHeight: 64,
        scale: 4,
    },
    {
        name: "superResolution_2",
        url: "https://hf-mirror.com/LXReaper/image_project/resolve/main/superResolution_2.onnx",
        backupUrl: "https://huggingface.co/LXReaper/image_project/resolve/main/superResolution_2.onnx",
        backupUrl1: "https://code.openxlab.org.cn/api/v1/repos/LXReaper/image_project/media/superResolution_2.onnx?ref=main&nonce=1747375308294",
        inputType: "float32",
        inputName: 'input.1',
        targetWidth: 64,
        targetHeight: 64,
        scale: 8,
    },
    {
        name: "superResolution_anime_1",
        url: "https://hf-mirror.com/LXReaper/image_project/resolve/main/superResolution_anime_1.onnx",
        backupUrl: "https://huggingface.co/LXReaper/image_project/resolve/main/superResolution_anime_1.onnx",
        backupUrl1: "https://code.openxlab.org.cn/api/v1/repos/LXReaper/image_project/media/superResolution_anime_1.onnx?ref=main&nonce=1747375343575",
        inputType: "float32",
        inputName: 'input.1',
        targetWidth: 64,
        targetHeight: 64,
        scale: 4,
    },
    {
        name: "superResolution_anime_video1",
        url: "/models/superResolution_anime_video1.onnx",
        backupUrl: "/models/superResolution_anime_video1.onnx",
        backupUrl1: "/models/superResolution_anime_video1.onnx",
        inputType: "float32",
        inputName: 'input',
        targetWidth: 64,// 可以自定义
        targetHeight: 64,// 可以自定义
        scale: 4,
    },
]

/**
 * 一些demo图片
 */
export const DemoBgImageList = [
    '/images/my_tools/ybgp/d30a15a6aceb41b5ac1ed8f5d5805394.jpg',
    '/images/my_tools/ybgp/f0ce489a97a54e6c80309a8e27e94d7a.png',
    '/images/my_tools/ybgp/27205e04471f4e6bb855af8d1099b2d2.jpg',
    '/images/my_tools/ybgp/39a08a45bc004554a3383b831d1b8055.jpg',
    '/images/my_tools/ybgp/4313dbe0b4da4d1f8fc1c0841871e955.jpg',
    '/images/my_tools/ybgp/8eff3cf52a154bc1b5892fda21ea91c4.png',
    '/images/my_tools/ybgp/2b86dc2429b642aebdd284cf77e580f2.jpg',
    '/images/my_tools/ybgp/55511f3c53e240beaba52e08d4931873.jpg',
    '/images/my_tools/ybgp/75a1b103e752417fbde2dd23452aabad.jpg',
    '/images/my_tools/ybgp/7ab04fbe3dd34bd8ae07a192ed3cae00.jpg',
    '/images/my_tools/ybgp/97a118aedcff499f97ab8a3542fe3cb9.jpg',
    '/images/my_tools/ybgp/e843635c8251484485da99af5730bfeb.jpg',
    '/images/my_tools/ybgp/9dd391b6fec64bc29f0ff4f6a8d5f45f.png',
    '/images/my_tools/ybgp/19ffef708c8b42f0803e317c8a1ea3c9.png',
    '/images/my_tools/ybgp/05fb3f17bd7d4fc38cb2bdc68ff317df.png',
    '/images/my_tools/ybgp/fbba81b5b27b4a569d096b37e86a51a8.png',
    '/images/my_tools/ybgp/2479bca3500c4907a4c6eec03ff90473.png',
    '/images/my_tools/ybgp/38014aae009347658a420f14c5be1721.png',
    '/images/my_tools/ybgp/890d7ded1b994d35b36274d1106856f3.jpg',
    '/images/my_tools/ybgp/a984642bab204f1abe19496a31ed36df.jpg',
    '/images/my_tools/ybgp/771a4d73c3264fdba2dd0f97b25cbb2b.jpg',
    '/images/my_tools/ybgp/86c60c11674949e8b2beafec12ab610d.jpg',
    '/images/my_tools/ybgp/9b0b6c6915454b5f9265aee5b01c6bc0.jpg',
    '/images/my_tools/ybgp/9fc6816376ef43c4aaf62f3fa20d8969.jpg',
    '/images/my_tools/ybgp/b75669e82217484db5c6fda2378db181.jpg',
    '/images/my_tools/ybgp/c14d4123a23646de867b45af9f2f687c.jpg',
    '/images/my_tools/ybgp/df8b1b348f544c9c8c87c012faee2d83.jpg',
    '/images/my_tools/ybgp/e4654e545f1c465d82068eb1e045aede.jpg',
    '/images/my_tools/ybgp/6dc3cf36883b40bab5698579c0af1c00.jpg',
    '/images/my_tools/ybgp/c2bd041f7eb34d3c87e255611ce6bf1d.jpg',
    '/images/my_tools/ybgp/4ed95c8d9b5c48f9bd12fa11e490ddcf.png',
    '/images/my_tools/ybgp/5d3ad3b87e47489cba15949bb597bb69.png',
    '/images/my_tools/ybgp/bf1fee0ee6eb49ccac8c94c82e4b1073.png',
    '/images/my_tools/ybgp/e756c3221b1f4046bd1981569e54f5eb.png',
    '/images/my_tools/ybgp/faa805b3af47496491ccdd5ac3a4c74f.png',
    '/images/my_tools/ybgp/1f0c10bb282c4a9f91c5e4d0bf31959f.png',
    '/images/my_tools/ybgp/72490794b5dc4911b4cc7583100f6d65.jpg',
    '/images/my_tools/ybgp/9ca9a29bece54e0aa379ad1aa5bce35d.png',
    '/images/my_tools/ybgp/3913a4c16b3644e7aa477b0f0bd17a9d.png',
    '/images/my_tools/ybgp/12dc5bde425d42418b8f0f428c29f153.png',
    '/images/my_tools/ybgp/0ea048ea4ed645c5bd7d32b546c09d0c.png',
    '/images/my_tools/ybgp/2ecf46acd8214c33b12228a7ad141ae2.png',
    '/images/my_tools/ybgp/3344e37bbb6346e89671410cc6ff38df.png',
    '/images/my_tools/ybgp/7c89d6a82412406da6057fa6b73337b9.png',
    '/images/my_tools/ybgp/8d77d9dd3f0f49b7a462399e9f2b6302.png',
    '/images/my_tools/ybgp/a136cbd2f49d4e9c9b534dd99e10a87b.png',
    '/images/my_tools/ybgp/c7a005e994f1467fa527f34b5665f0b5.png',
    '/images/my_tools/ybgp/b33975de77f44ed3ad0a39ffb8a10b4f.png',
    '/images/my_tools/ybgp/6842a3f0fee74525a6852d2b71197033.png',
    '/images/my_tools/ybgp/23ac341ef6b74ca9a10cea8676900263.png',
    '/images/my_tools/ybgp/2a9a7675cee24a9d964c32570820f6e0.jpg',
];
